module.exports = __webpack_public_path__ + "static/media/iconFour.73862617.svg";